import { getTags } from '../../api/tags';
import { GET_TAGS, SET_TAGS, ERROR_TAGS } from '../actionTypes/tags';

export function getList() {
    return async(dispatch) => {
        try {
            dispatch({
                type: GET_TAGS,
                payload: {
                    fetching: true,
                },
            });

            const data = await getTags();
            const { items } = data;

            dispatch({
                type: SET_TAGS,
                payload: {
                    fetching: false,
                    items,
                },
            });

        } catch (error) {
            const errorMsg = error.message || error;
            dispatch({
                type: ERROR_TAGS,
                payload: {
                    fetching: false,
                    fetchError: errorMsg,
                },
            });
            console.info('Action: TAGS getList error', errorMsg);
        }
    };
}
